import React, { useRef, useState, useEffect } from 'react';
import { Modal, FormGroup } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import Select from 'react-select';
import Loader from '../../../../../Components/Utility/Loader/Loader';
import UploadFileAndDocument from '../../../../../Components/UploadFileAndDocument/UploadFileAndDocument';
import { customStyles } from '../../../../../Components/helper';
import * as componentAction from '../../../store/component.action';

const statusOption = [
  { _id: 1, name: 'Approved' },
  { _id: 2, name: 'Rejected' },
  { _id: 3, name: 'Not Applicable' },
];

function UploadDocuments({ onOpen, toggle, showData }) {
  const { t } = useTranslation('common');
  const childRef = useRef();
  const dispatch = useDispatch();

  const [state, setState] = useState({
    name: '',
    notes: '',
    isVisibletoSupplier: '',
    status: null,
    loading: false,
    fromSubmit: false,
    fileMissing: false,
  });
  const [fileName, setFileNames] = useState('');
  const apiCalls = async (err, formData) => {
    if (!err) {
      setState((hasFile) => ({
        ...hasFile,
        loading: true,
      }));
      const res = await dispatch(componentAction.postPODocuments(formData, t));
      if (res) {
        setState((hasFile) => ({
          ...hasFile,
          loading: false,
        }));
        toggle();
      }
    }
  };
  useEffect(() => {
    setState((hasFile) => ({
      ...hasFile,
      name: fileName,
    }));
  }, [fileName]);

  const addDocument = async () => {
    setState((submitState) => ({
      ...submitState,
      fromSubmit: true,
    }));
    const formData = new FormData();
    if (childRef?.current) {
      const uploadedDoc = await childRef?.current?.selectedDocument();

      let err = false;
      if (uploadedDoc) {
        const { document } = uploadedDoc;
        formData.append('poId', showData._id);
        formData.append('status', state.status?.name);
        formData.append('notes', state.notes);
        formData.append('fileName', state.name);
        formData.append('isVisibleToSupplier', state.isVisibletoSupplier);
        formData.append('document', document);
      } else {
        err = true;
      }
      if (state.name.trim()) {
        apiCalls(err, formData);
      }
    } else {
      setState((errState) => ({ ...errState, fileMissing: true }));
    }
  };

  const inputChanges = (e) => {
    if (e?.target?.name === 'documentName') {
      setState((previousNames) => ({
        ...previousNames,
        name: e.target.value,
      }));
    } else {
      setState((previousNotes) => ({
        ...previousNotes,
        notes: e.target.value,
      }));
    }
  };

  const onStatusChange = (e) => {
    setState((stated) => ({
      ...stated,
      status: e,
    }));
  };

  return (
    <Modal className="custom-modal modal-medium-3x supplier-overview-modal" size="lg" show={onOpen} onHide={toggle} backdrop="static" centered>
      <Modal.Header>
        <Modal.Title>{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.UPLOAD_DOCUMENT.MODAL_TITLE')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {state.loading ? (
          <Loader />
        ) : (
          <>
            <UploadFileAndDocument
              showTitleField={false}
              ref={childRef}
              acceptedFileExtenstion=".xls, .xlsx, .pdf, .psd, .doc, .txt, .rar, .png, .jpeg, .jpg, .bmp, .tif, .raw, .etc, .gif, .ppt, .svg, .exp"
              setFileNames={setFileNames}
              fromPO
            />
            {state.fileMissing && (
              <small className="error-message">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.UPLOAD_DOCUMENT.FILE_MISSING_ERROR')}</small>
            )}
            <div className="mt-3">
              <FormGroup>
                <div>
                  <input
                    type="text"
                    name="documentName"
                    placeholder="Document Title *"
                    value={state.name}
                    className="form-control text-bordered"
                    onChange={inputChanges}
                  />
                </div>
                {isEmpty(state.name) && state.fromSubmit && (
                  <small className="error-message">
                    {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.UPLOAD_DOCUMENT.DOCUMENT_TITLE_ERROR')}
                  </small>
                )}
              </FormGroup>
            </div>
            <div className="mt-3">
              <FormGroup>
                <label>{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.UPLOAD_DOCUMENT.NOTES_LABEL')}</label>
                <div>
                  <input
                    type="text"
                    name="notes"
                    placeholder={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.UPLOAD_DOCUMENT.NOTES_LABEL')}
                    value={state.notes}
                    className="form-control"
                    onChange={inputChanges}
                  />
                </div>
              </FormGroup>
            </div>
            <div className="mt-3">
              <FormGroup>
                <div>
                  <Select
                    name="status"
                    maxMenuHeight={132}
                    menuPlacement="top"
                    menuPosition="fixed"
                    options={statusOption}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option._id}`}
                    value={state.status}
                    styles={customStyles}
                    onChange={(e) => onStatusChange(e)}
                    placeholder={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.UPLOAD_DOCUMENT.STATUS_PLACEHOLDER')}
                  />
                </div>
              </FormGroup>
            </div>

            <div className="modal-buttons mt-3 d-flex justify-content-between">
              <button className="btn btn-default" type="button" onClick={toggle}>
                {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.UPLOAD_DOCUMENT.BACK_BUTTON')}
              </button>
              <button className="btn btn-default" type="button" onClick={addDocument} disabled={state.fileMissing}>
                {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.UPLOAD_DOCUMENT.ADD_BUTTON')}
              </button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default UploadDocuments;
